import { forwardRef, type Ref, type SVGProps } from "react";
const IconMovingTruckOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m24.935 10.284 3.196 4.758c1.031.002 1.867.857 1.869 1.912v3.815q0 .026-.004.05l-.004.051c-.056 1.012-.87 1.805-1.861 1.81 0 2.108-1.67 3.816-3.731 3.816s-3.73-1.708-3.73-3.815h-8.4c0 2.109-1.673 3.819-3.735 3.819-2.063 0-3.735-1.71-3.735-3.82H3.68a1.6 1.6 0 0 1-.774-.201A1.72 1.72 0 0 1 2 20.963V7.218c.004-.947.754-1.714 1.68-1.718h13.44c.926.004 1.676.77 1.68 1.718v2.097h4.513c.672 0 1.293.37 1.622.969m-1.622.943H18.8v3.815h7.066l-.206-.312-2.265-3.368zM8.53 24.592c-1.033 0-1.87-.855-1.87-1.911s.837-1.912 1.87-1.912c1.032 0 1.869.856 1.869 1.912 0 .507-.196.994-.547 1.352-.35.36-.826.56-1.322.56m14-1.911c0 1.055.836 1.911 1.869 1.911 1.031-.002 1.867-.857 1.87-1.911 0-1.056-.838-1.912-1.87-1.912s-1.87.856-1.87 1.912M16.875 7.41v13.36h-5.124a3.7 3.7 0 0 0-2.618-1.855 3.64 3.64 0 0 0-3.057.912 4 4 0 0 0-.757.943h-1.45v-3.815h8.4a.946.946 0 0 0 .935-.956.946.946 0 0 0-.935-.956h-8.4v-7.63zm1.885 9.543h9.37l.026 3.813-.544.002a3.69 3.69 0 0 0-3.212-1.9c-1.326 0-2.55.725-3.212 1.9 0 0-1.124.022-2.43.022l.002-3.167z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconMovingTruckOutlineSVG);
ForwardRef.displayName = "IconMovingTruckOutline";
export { ForwardRef as IconMovingTruckOutline };
